<template>
	<span>
		<span  v-for="info in infos">
			<b-badge :title="info.title" :variant="info.status">
				{{ info.title }}
			</b-badge>
		</span>
	</span>
	
</template>

<script>
export default {
	props: ["infos"],
	data() {
		return {

		};
	},
	methods: {

	},
	beforeMount() {
	},
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Orders_v2/Aggregates/BadgeInfo.vue